import MenuItem from '@mui/material/MenuItem';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FC, memo, useCallback } from 'react';

import { RoutePath } from '../route/type';

const SX_MENU_ITEM: SxProps<Theme> = {
  '&:last-child a:after': {
    display: 'none',
  },
  display: 'list-item',

  padding: 0,
};

const SX_ROUTE: SxProps<Theme> = {
  '&:after': {
    backgroundColor: '#edc66754',
    bottom: '-2px',
    height: '1px',
    transform: 'scaleX(1)',
    visibility: 'visible',
  },
  color: '#fff',
  display: 'block',
  fontWeight: '600',
  letterSpacing: '2px',
  lineHeight: '40px',
  margin: '0.5rem 1.25rem',
  textAlign: 'center',

  textTransform: 'uppercase',
};

type MobileMenuItemProps = {
  href: RoutePath | string;
  onClick: (href: RoutePath | string) => void;
  text: string;
};

const MobileMenuItem: FC<MobileMenuItemProps> = ({ href, onClick, text }) => {
  const handleClick = useCallback((href: RoutePath | string) => onClick(href), [onClick]);

  return (
    <MenuItem disableRipple onClick={() => handleClick(href)} sx={SX_MENU_ITEM}>
      <Typography component='a' sx={SX_ROUTE} variant='body2'>
        {text}
      </Typography>
    </MenuItem>
  );
};

export default memo(MobileMenuItem);
